import type { SupabaseClient } from '@supabase/supabase-js';

/** Role for career-site applicants in public.users */
export const CAREER_USER_ROLE = 'user';

export const NOT_CAREER_USER_MESSAGE =
  'This account is not registered for job applications. Please use the correct sign-in page.';

export const USER_RECORD_MISSING_MESSAGE =
  'Your account is not set up yet. Please try signing up again or contact support.';

export type UsersRow = {
  id: string;
  role: string;
  email: string | null;
  name: string | null;
};

export async function getUsersRecord(
  supabase: SupabaseClient,
  userId: string
): Promise<UsersRow | null> {
  const { data, error } = await supabase
    .from('users')
    .select('id, role, email, name')
    .eq('id', userId)
    .maybeSingle();

  if (error || !data) return null;
  return data as UsersRow;
}

export async function assertCareerUserAccess(
  supabase: SupabaseClient,
  userId: string
): Promise<
  | { allowed: true; record: UsersRow }
  | { allowed: false; message: string; missing?: boolean }
> {
  const record = await getUsersRecord(supabase, userId);

  if (!record) {
    return { allowed: false, message: USER_RECORD_MISSING_MESSAGE, missing: true };
  }

  if (record.role !== CAREER_USER_ROLE) {
    return { allowed: false, message: NOT_CAREER_USER_MESSAGE };
  }

  return { allowed: true, record };
}
